module.exports = __webpack_public_path__ + "static/img/happy-icon.b0807d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/happy-icon.png
// module id = I6+k
// module chunks = 0